<template>
    <!-- 头部整体盒子 -->
    <div id="header" class="container-fuild">
        <!-- 头部顶部 -->
        <div class="header-top container-fuild hidden-xs">
            <div class="container">
                <div class="server pull-left">
                    <span class="glyphicon glyphicon-earphone"></span>{{config.tel}}
                    <span class="glyphicon glyphicon-envelope"></span>{{config.email}}
<!--                    <span class="glyphicon glyphicon-time"></span>7x24小时为您服务-->
                </div>
                <div class="shejiao pull-right">
                    <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
                    <span class="glyphicon glyphicon-hand-left"></span>
                </div>
            </div>
        </div>
        <!-- 电脑导航 -->
        <div class="header-nav container hidden-xs">
            <!-- 导航logo -->
            <div class="header-nav-logo">
                <img src="@/assets/img/logo/logo_white.png">
            </div>
            <!-- 导航内容 -->
            <ul class="header-nav-wrapper">
                <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''" @click="navClick(index,item)">
                    <router-link :to="item.path">
                        {{item.name}}
                        <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
<!--                        <i class="underline"></i>-->
                        <i :class="['iconfont',item.iconfont]"></i>
                    </router-link>
                    <dl v-if="item.children.length>0">
                        <dt v-for="(i,n) in item.children" :key="n">
                            <router-link :to="i.path">{{i.name}}</router-link>
                        </dt>
                    </dl>
                </li>
            </ul>
        </div>
        <!-- 手机导航 -->
        <div class="header-nav-m container-fuild visible-xs">
            <div class="header-nav-m-logo">
                <img class="center-block" src="@/assets/img/logo/logo_white.png" alt="logo">
            </div>
            <i class="iconfont icon-caidan" @click="menuClick" data-toggle="collapse" data-target="#menu"></i>
            <!-- 导航栏 -->
            <div class="header-nav-m-menu text-center">
<!--                {{menuName}}-->
                <!--<div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
                    <span :class="menuClass"></span>
                </div>-->

                <!-- 导航内容 -->
                <ul id="menu" class="header-nav-m-wrapper collapse">
                    <li v-for="(item,index) in navList"
                        :key="index"
                        :class="index==navIndex?'active':''"
                        @click="navClick(index,item)"
                        data-toggle="collapse"
                        data-target="#menu">
                        <router-link :to="item.path">
                            {{item.name}}
                            <i class="underline"></i>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import config from '@/config'

    export default {
        name: "Header",
        data() {
            return {
                config: config,
                navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
                menuName: "骏驰首页",
                menuClass: "glyphicon glyphicon-menu-down",
                navList: [
                    {
                        name: "骏驰首页",
                        path: "/",
                        iconfont: 'icon-shouye',
                        children: []
                    },
                    {
                        name: "产品服务",
                        path: "/HomePage",
                        iconfont: 'icon-icon_yingyongguanli',
                        children: []
                    },
                    /*{
                        name: "电子商务",
                        path: "/Electronic",
                        iconfont: 'icon-biji',
                        children: []
                    },*/
                    /*{
                        name: "成功案例",
                        path: "/software",
                        children: [
                            /!*{
                                name: "平台",
                                path: "/software/smartTown"
                            },
                            {
                                name: "App端",
                                path: "/software/bigData"
                            }*!/
                        ]
                    },*/

                    /*{
                        name: "企业架构",
                        path: "/Enterprise",
                        iconfont: 'icon-biji',
                        children: []
                    },*/
                    /*{
                        name: "新闻动态",
                        path: "/newsinformation",
                        children: []
                    },*/
                    {
                        name: "公司介绍",
                        path: "/companyintroduction",
                        iconfont: 'icon-yonghu',
                        children: []
                    },
                    /*{
                        name: "工作机会",
                        path: "/jobchance",
                        children: []
                    },
                    {
                        name: "联系我们",
                        path: "/contactus",
                        children: []
                    }*/
                ]
            };
        },
        computed: {
            navActive() {
                return this.$store.getters.getActive;
            }
        },
        watch: {
            '$route'(newVal) {
                let obj = this.navList.find(item => item.path === newVal.path);
                this.menuName = obj ? obj.name : '骏驰首页';
            },
            navActive(newVal) {
                if(this.navActive) {
                    this.navIndex = 1;
                    this.menuName = '产品服务'
                }
            }
        },
        created() {
            let index = sessionStorage.getItem('navIndex');
            let menuName = sessionStorage.getItem('menuName');
            if(index) this.navIndex = index;
            if(menuName) this.menuName = menuName;
        },
        methods: {
            navClick(index, item) {
                this.navIndex = index;
                sessionStorage.setItem('navIndex', index);
                sessionStorage.setItem('menuName', item.name);
                this.menuName = item.name;
                this.$router.push(item.path);
            },
            menuClick() {
                if (this.menuClass == "glyphicon glyphicon-menu-down") {
                    this.menuClass = "glyphicon glyphicon-menu-up";
                } else {
                    this.menuClass = "glyphicon glyphicon-menu-down";
                }
            }
        }
    };
</script>
<style scoped lang="scss">
    /* 顶部 */
    #header {
        background: #f4f4f4;
        transition: all ease 0.6s;
    }

    #header .header-top {
        height: 50px;
        color: #fff;
        font-size: 12px;
        line-height: 50px;
        background: #474747;
    }

    /* 顶部的图标 */
    #header .header-top span {
        margin: 0 8px;
    }

    /* 导航栏 */
    #header .header-nav {
        height: 110px;
    }

    /* 导航栏logo */
    #header {
        .header-nav {
            .header-nav-logo {
                width: auto;
                height: 100%;
                float: left;
                position: relative;
            }
            img {
                width: 220px;
                height: 100%;
                margin: auto;
            }
        }
    }

    /* 导航栏 导航容器 */
    #header {
        .header-nav-fixed {
            .header-nav-wrapper {
                line-height: 50px;
            }
        }
        .header-nav {
            .header-nav-wrapper {
                padding-left: 100px;
                height: 110px;
                margin: 0;
                /*max-width: 800px;*/
                display: flex;
                flex-direction: row;
                align-items: center;
                li {
                    margin: 0 20px;
                    a {
                        display: block;
                        /*color: #000;*/
                        /*font-size: 15px;*/
                        /*font-weight: bold;*/
                        /*padding: 15px 0;*/
                        position: relative;
                        height: 30px;
                        /*background-color: #fff;*/
                        border: none;
                        border-radius: 20px;
                        color: #363643;
                        font-size: 14px;
                        line-height: 30px;
                        padding-left: 30px;
                        padding-right: 20px;
                        box-sizing: border-box;
                        &:hover {
                            /*color: #1e73be;*/
                            text-decoration: none;
                            background-color: #2E81EA;
                            color: #fff;
                            i {
                                opacity: 1;
                            }
                        }
                        i {
                            display: block;
                            position: absolute;
                            top: 50%;
                            left: 8px;
                            transform: translateY(-50%);
                            /*width: 0;
                            height: 2px;*/
                            opacity: 0;
                            transition: all 0.6s ease;
                            /*background-color: #1e73be;*/
                            font-size: 15px;
                            color: #fff;
                        }
                        span {
                            font-size: 12px;
                            transition: transform ease 0.5s;
                        }
                    }
                    &.active {
                        a {
                            text-decoration: none;
                            background-color: #2E81EA;
                            color: #fff;
                            i {
                                opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }
    /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
    #header .header-nav .header-nav-wrapper > li > a:hover .underline {
        opacity: 1;
        width: 100%;
        left: 0;
    }

    /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
    #header .header-nav .header-nav-wrapper > li > a:hover span {
        transform: rotate(180deg);
    }

    /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
    #header .header-nav .header-nav-wrapper > li.active > a {
        /*color: #1e73be;*/
        text-decoration: none;
        /*border-bottom: 2px solid #1e73be;*/
    }

    /* 导航栏 每个导航下面的二级导航容器 */
    #header .header-nav .header-nav-wrapper > li > dl {
        display: none;
        position: absolute;
        width: 168px;
        top: 80%;
        left: 0;
        z-index: 999999;
        box-shadow: 0 0 3px 1px #ccc;
        background: #fff;
    }

    /* 导航栏 每个导航下面的二级导航容器的每个导航 */
    #header .header-nav .header-nav-wrapper > li > dl > dt {
        width: 100%;
        padding: 10px;
        border-bottom: 1px solid #ccc;
    }

    /* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
    #header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
        text-decoration: none;
    }

    /* 导航栏 滑上一级导航显示二级导航 */
    #header .header-nav .header-nav-wrapper > li:hover dl {
        display: block;
    }

    #header .header-nav .header-nav-wrapper > li > dl > dt:hover {
        cursor: pointer;
        background: #ccc;
    }

    @media screen and (max-width: 997px) {
        #header .header-nav-m {
            position: relative;
            .icon-caidan {
                position: absolute;
                top: 50%;
                right: 20px;
                transform: translateY(-50%);
                font-size: 35px;
                color:#2E81EA;
            }
        }

        /* 导航栏logo容器 */
        #header .header-nav-m .header-nav-m-logo {
            height: 80px;
            position: relative;
        }

        /* 导航栏logo图片 */
        #header .header-nav-m .header-nav-m-logo img {
            width: 135px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
        }

        /* 导航栏  菜单容器 */
        #header .header-nav-m .header-nav-m-menu {
            color: #fff;
            /*height: 50px;*/
            font-size: 20px;
            /*line-height: 50px;*/
            background: #474747;
            position: relative;
        }

        /* 导航栏 菜单图标 */
        #header .header-nav-m .header-nav-m-menu-wrapper {
            position: absolute;
            top: 50%;
            right: 20px;
            margin-top: -20px;
            width: 50px;
            height: 40px;
            color: #fff;
            z-index: 999999;
            font-size: 12px;
        }

        /* 导航栏 */
        #header .header-nav-m .header-nav-m-wrapper {
            position: absolute;
            /*top: 50px;*/
            left: 0;
            width: 100%;
            background: #474747;
            /*background-color: #ffffff;*/
            z-index: 9999999;
        }

        /* 导航栏 每个导航 */
        #header .header-nav-m .header-nav-m-wrapper > li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #ccc;
            &.active {
                background: #2E81EA;
                a {
                    color: #ffffff;
                }
            }
        }

        /* 导航栏 每个导航下面的 a 链接 */
        #header .header-nav-m .header-nav-m-wrapper > li > a {
            color: #fff;
            /*color: #000;*/
            font-size: 15px;
            /*font-weight: bold;*/
            padding: 15px 0;
            position: relative;
        }

        /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
        #header .header-nav .header-nav-wrapper > li > a > span {
            font-size: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue